import axiosInstance from '../../../../config/axiosInstance';
const  IssueStatusService = {
    async GetAllIssueStatus(redirectCallback, Start, PageSize, searchQuery, sortColumn, sortDirection, SearchColumns) {
        try {    
              Start = Start ?? 1;
            PageSize = PageSize ?? 1000;
            searchQuery = searchQuery ?? "";
            sortColumn = sortColumn ?? "ID";
            sortDirection = sortDirection ?? "DESC";
            SearchColumns = SearchColumns ?? "";        
            const ClientID=localStorage.getItem('CompanyID');
            const UserID=localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Setup/GetIssueStatus?ClientID=${ClientID}&Start=${Start}&PageSize=${PageSize}&searchQuery=${searchQuery}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&UserID=${UserID}&SearchColumns=${SearchColumns}`);
            return response.data;
        } catch (error) {
            if(error.response.data.message=="Invalid token")
            {
                redirectCallback();
                return;
            }
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async DeleteIssueStatus(ID,redirectCallback) {
        try {
           const response = await axiosInstance.get(`/Setup/DeleteIssueStatus?ID=${ID}`);
           return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async SetDefaulIssueStatus(ID,redirectCallback) {
        try {
            const ClientID=localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Setup/SetDefaulIssueStatus?ID=${ID}&ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async SetCloseIssueStatus(ID,redirectCallback) {
        try {
            const ClientID=localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Setup/SetCloseIssueStatus?ID=${ID}&ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async SetCompleteIssueStatus(ID,redirectCallback) {
        try {
            const ClientID=localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Setup/SetCompleteIssueStatus?ID=${ID}&ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    }
};

export default IssueStatusService;